import { useState } from "react";
import { categories, articles } from "@/mocks/data";
import ArticleCard from "@/components/base/ArticleCard";

export default function FeaturedArticles() {
  const [activeCategory, setActiveCategory] = useState("all");

  const filteredArticles =
    activeCategory === "all"
      ? articles.slice(0, 6)
      : articles.filter((a) => a.category === activeCategory).slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            精选文章
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            精选优质内容，为您提供最实用的观影指南与行业知识
          </p>
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2 mb-10">
          <button
            onClick={() => setActiveCategory("all")}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
              activeCategory === "all"
                ? "bg-primary-500 text-white"
                : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70"
            }`}
          >
            全部
          </button>
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.slug
                  ? "bg-primary-500 text-white"
                  : "bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        {filteredArticles.length === 0 && (
          <div className="text-center py-12 text-foreground-500 text-sm">
            暂无该分类的文章
          </div>
        )}
      </div>
    </section>
  );
}